module.exports = __webpack_public_path__ + "img/txt.bb1574e1.svg";